import api from '@/services/api';

interface ReportTemplateApiItem {
  id: string;
  name: string;
  metadata?: Record<string, any>;
  updated_at?: string;
  updatedAt?: string;
}

interface ReportTemplateListApiResponse {
  data?: ReportTemplateApiItem[];
}

interface CreateReportTemplatePayload {
  name: string;
  metadata: Record<string, any>;
}

export interface ThematicSessionTemplate {
  id: string;
  name: string;
  props: Record<string, any>;
  updatedAt: string;
}

const mapApiItemToTemplate = (item: ReportTemplateApiItem): ThematicSessionTemplate => ({
  id: item.id,
  name: item.name,
  props: item.metadata ?? {},
  updatedAt: item.updated_at ?? item.updatedAt ?? new Date().toISOString(),
});

const parseListResponse = (response: ReportTemplateApiItem[] | ReportTemplateListApiResponse) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  return [];
};

export async function loadThematicSessionTemplates(): Promise<ThematicSessionTemplate[]> {
  const queryParams = new URLSearchParams();
  queryParams.append('offset', '0');
  queryParams.append('limit', '100');
  const response = await api.get<ReportTemplateApiItem[] | ReportTemplateListApiResponse>(
    `/reports/templates?${queryParams.toString()}`
  );
  return parseListResponse(response.data).map(mapApiItemToTemplate);
}

export async function createThematicSessionTemplate(
  payload: CreateReportTemplatePayload
): Promise<ThematicSessionTemplate> {
  const response = await api.post<ReportTemplateApiItem>('/reports/templates', payload);
  return mapApiItemToTemplate(response.data);
}

export async function updateThematicSessionTemplate(
  id: string,
  payload: CreateReportTemplatePayload
): Promise<ThematicSessionTemplate> {
  const response = await api.patch<ReportTemplateApiItem>(`/reports/templates/${id}`, payload);
  return mapApiItemToTemplate(response.data);
}

export async function deleteThematicSessionTemplate(id: string): Promise<void> {
  await api.delete(`/reports/templates/${id}`);
}
